import { Page } from '@distribute/shared/types';
import { FILTER_PAGE_ITEMS } from '../config';

export const getFilteredPages = (
  pages: Page[],
  state: keyof typeof FILTER_PAGE_ITEMS
) => {
  switch (state) {
    case 'notPublished':
      return pages.filter((i) => !i.published);
    case 'published':
      return pages.filter((i) => i.published);
    default:
      return pages;
  }
};
